import { render } from "./FooterSubsection.vue?vue&type=template&id=73d55863&ts=true"
import script from "./FooterSubsection.vue?vue&type=script&lang=ts"
export * from "./FooterSubsection.vue?vue&type=script&lang=ts"

import "./FooterSubsection.vue?vue&type=style&index=0&id=73d55863&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__